import { Route } from '@angular/router';
import { OrderSummaryIndexComponent } from '@features/order-summary/order-summary-index/order-summary-index.component';

export const order_summary_routes: Route[] = [
  {
    path: ':id',
    pathMatch: 'full',
    component: OrderSummaryIndexComponent,
    title: 'Order Summary'
  },
  {
    path: '',
    pathMatch: 'full',
    component: OrderSummaryIndexComponent,
    title: 'Order Summary'
  }
];
